<template>
  <div class="table-responsive">
    <div class="container-table">
      <table class="table table-bordered">
        <caption></caption>
        <thead>
          <tr>
            <th class="text-center" style="white-space: nowrap, width= 50">
              Alterado por
            </th>
            <th class="text-center" style="white-space: nowrap, width= 10">
              Ação
            </th>
            <th class="text-center" style="white-space: nowrap, width= 50">
              Campos alterados
            </th>
            <th class="text-center" style="white-space: nowrap, width= 10">
              Data
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="audit in data">
            <tr
              data-toggle="collapse"
              :data-target="'#fields' + audit.id"
              class="clickable pointer"
              :key="audit.id"
            >
              <td class="text-center">{{ audit.user.name }}</td>
              <td class="text-center">{{ audit.event | audit_event }}</td>
              <td class="text-center">
                {{
                  (audit.event == 'updated'
                    ? audit.new_values
                    : audit.event == 'deleted'
                    ? audit.old_values
                    : {}) | audit_fields_proposals
                }}
              </td>
              <td class="text-center">{{ audit.created_at | date }}</td>
            </tr>
            <tr
              class="collapse out"
              :id="'fields' + audit.id"
              :key="'values' + audit.id"
            >
              <td colspan="4">
                <ProposalHistoryValuesTable :audit="audit" />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import ProposalHistoryValuesTable from '@/components/customers/proposals/CustomerProposalHistoryValuesTable';

export default {
  mixins: [returnMessageFormMixin],
  name: 'ProposalHistory',
  components: { ProposalHistoryValuesTable },
  data() {
    return {
      data: [],
      page: 1,
    };
  },
  methods: {
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}`;
      return filters;
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/proposal/${this.proposalId}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
  },
  beforeMount() {
    if (this.proposalId) {
      this.getDatas();
    }
  },
  computed: {
    proposalId() {
      return this.$store.state.showProposalSave;
    },
  },
};
</script>
